import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

function useRankingView(month?: number){
    interface ranking {
        id: string;
        name: string;
        score: number;
        rank: number;
    }
    const [rankingList, setRankingList] = useState<ranking[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const {readFirestoreWithSort, readFirestoreOneDoc, updateFirestore} = useFirestore();
    const {getBranchId} = useGetBranchId();

    const getRankingList = async() => {
        setIsLoading(true);
        const branch_id = await getBranchId();
        const year = new Date().getFullYear();
        const targetMonth = month || new Date().getMonth() + 1;
        const snapshot = await readFirestoreWithSort(`TossScore/${branch_id}/${year}/${targetMonth}/Score`, {name:"score", direction:"desc"});
        if(snapshot.empty) {
            setRankingList([]);
            setIsLoading(false);
            return;
        }

        const rankingList = await Promise.all(snapshot.docs.map(async(doc:any, idx:number) => {
            const student_id = doc.id;
            const studentInfo = await getStudentInfo(student_id);
            return {
                id: doc.id,
                name: studentInfo?.name ?? "이름 없음",
                score: doc.data().score,
                rank: idx + 1
            }
        }));
        setRankingList(rankingList);
        setIsLoading(false);
    }

    const getStudentInfo = async(student_id:string) => {
        const snapshot = await readFirestoreOneDoc("User/Auth/Student", student_id);
        if(!snapshot.exists()) return null;
        return snapshot.data();
    }

    const updateScore = async (studentId: string, change: number) => {
        try {
            const student = rankingList.find(item => item.id === studentId);
            if (!student) return false;

            const newScore = student.score + change;
            if (newScore < 0) return false; // 점수가 0 미만이 되지 않도록

            const branch_id = await getBranchId();
            const year = new Date().getFullYear();
            const targetMonth = month || new Date().getMonth() + 1;
            
            // Firestore 업데이트
            await updateFirestore(
                `TossScore/${branch_id}/${year}/${targetMonth}/Score`,
                studentId,
                { score: newScore }
            );
            
            // 로컬 상태 업데이트
            setRankingList(prevList => {
                const newList = prevList.map(item => {
                    if (item.id === studentId) {
                        return { ...item, score: newScore };
                    }
                    return item;
                });
                // 점수 기준으로 정렬
                return newList.sort((a, b) => b.score - a.score);
            });

            return true;
        } catch (error) {
            console.error('점수 수정 실패:', error);
            return false;
        }
    };

    useEffect(() => {
        getRankingList();
    }, [month]);

    return{
        rankingList,
        isLoading,
        updateScore
    }
}

export default useRankingView;